var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#ffab00",
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.18 12a3 3 0 0 1 -3-3 3 3 0 0 1 6 0 3 3 0 0 1 -3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.85 21.69a6.14 6.14 0 0 1 6.15-6.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.93 24.76c3.24 0 5.86 4.14 5.86 9.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.15 21.69a6.14 6.14 0 0 1 -6.15-6.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 15.55-6.15 18.42"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.8052767ea94569e81d0de480183fb43b.svg";
export { ForwardRef as ReactComponent };